// CRNR Custom Scripts

(function() {
  // Add custom code below this line

  /**
   * Variant Thumbnail Image Swap
   * When hovering over a variant thumbnail in the product grid,
   * swap the main product image to show that variant's featured image.
   * Two strategies:
   *   1. Toggle visibility on pre-rendered variant image divs (theme swatch system)
   *   2. Fallback: directly swap the main <img> src + srcset
   */
  function initVariantSliders(root) {
    var scope = root || document;
    var sliders = [];

    if (scope.matches && scope.matches('grid-slider')) {
      sliders.push(scope);
    }

    scope.querySelectorAll('grid-slider').forEach(function(slider) {
      sliders.push(slider);
    });

    sliders.forEach(function(slider) {
      if (slider.isInitialized) return;

      requestAnimationFrame(function() {
        slider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
      });
    });
  }

  /* Color strips on combined-listing cards render with the card
     (snippets/crnr-card-color-strip.liquid). A thumb Liquid couldn't resolve
     (all_products over its 20-handle limit) arrives hidden with
     data-cc-fill-handle; fill it from /products/<handle>.js, once per handle
     per page. */
  var ccProductJson = {};
  function ccFillThumbs(scope) {
    scope.querySelectorAll('[data-cc-fill-handle]').forEach(function(thumb) {
      var handle = thumb.getAttribute('data-cc-fill-handle');
      thumb.removeAttribute('data-cc-fill-handle');
      if (!ccProductJson[handle]) {
        ccProductJson[handle] = fetch(window.theme.routes.root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function(res) { return res.ok ? res.json() : null; })
          .catch(function() { return null; });
      }
      ccProductJson[handle].then(function(product) {
        if (!product || !product.featured_image) return;
        // .js returns cdn.shopify.com URLs; Liquid's image_url uses the store's own CDN host
        var image = product.featured_image;
        if (window.Shopify && Shopify.cdnHost) {
          image = image.replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '//' + Shopify.cdnHost + '/shop/');
        }
        var src = image + (image.indexOf('?') > -1 ? '&' : '?');
        var img = thumb.querySelector('img');
        thumb.setAttribute('title', product.title);
        thumb.setAttribute('data-variant-thumb-title', product.title.replace(/"/g, "'"));
        thumb.setAttribute('data-variant-thumb-src', src + 'width=600');
        if (img) {
          img.setAttribute('alt', product.title);
          img.setAttribute('src', src + 'width=80');
        }
        var item = thumb.closest('[data-grid-item]');
        if (item) item.hidden = false;
      });
    });
  }

  // Strips arrive as an inert <template data-cc-strip>. A strip switches on
  // as soon as its card nears the screen; the rest (lower cards, cards inside
  // carousels) switch on a few at a time in idle moments, so none of this
  // work lands on page load or on a Load more click.
  var ccStripObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          ccStripObserver.unobserve(entry.target);
          ccAfterCardPhoto(entry.target, function() { ccActivateStrip(entry.target); });
        });
      }, { rootMargin: '300px 0px' })
    : null;

  // The card's own photo should appear before its swatch thumbs: wait for it
  // (at most 1.5s) before switching the strip on.
  function ccAfterCardPhoto(container, fn) {
    var card = container.closest('[data-grid-item]');
    var img = card && card.querySelector('[data-product-image-default] img');
    if (!img || (img.complete && img.naturalWidth)) return fn();
    var done = false;
    var go = function() { if (!done) { done = true; fn(); } };
    img.addEventListener('load', go, { once: true });
    img.addEventListener('error', go, { once: true });
    setTimeout(go, 1500);
  }
  var ccStripQueue = [];
  var ccStripIdleScheduled = false;
  var ccIdle = window.requestIdleCallback || function(cb) {
    return setTimeout(function() { cb({ timeRemaining: function() { return 8; } }); }, 50);
  };

  function ccScheduleStrips() {
    if (ccStripIdleScheduled || !ccStripQueue.length) return;
    ccStripIdleScheduled = true;
    ccIdle(function(deadline) {
      ccStripIdleScheduled = false;
      while (ccStripQueue.length && deadline.timeRemaining() > 6) {
        var next = ccStripQueue.shift();
        var nextBox = next.getBoundingClientRect();
        // cards on or near the screen are the observer's job (photo first)
        if (ccStripObserver && nextBox.width &&
            nextBox.bottom > -300 && nextBox.top < window.innerHeight + 300 &&
            nextBox.right > 0 && nextBox.left < window.innerWidth) continue;
        ccActivateStrip(next);
      }
      ccScheduleStrips();
    }, { timeout: 2000 });
  }

  function ccActivateStrip(container) {
    if (ccStripObserver) ccStripObserver.unobserve(container);
    var pending = container.querySelector('template[data-cc-strip]');
    if (!pending) return;
    pending.replaceWith(pending.content);
    initVariantThumbnailSwap(container);
    requestAnimationFrame(function() {
      container.querySelectorAll('.grid--slider').forEach(ccBuildSwatchArrows);
    });
  }

  function initVariantThumbnailSwap(root) {
    if (root instanceof Event) root = undefined;
    var scope = root || document;
    var containers = [];

    if (scope.matches && scope.matches('[data-variant-thumbnails]')) {
      containers.push(scope);
    }

    scope.querySelectorAll('[data-variant-thumbnails]').forEach(function(container) {
      containers.push(container);
    });

    containers.forEach(function(container) {
      if (container.querySelector('template[data-cc-strip]')) {
        if (!container.dataset.ccStripWatched) {
          container.dataset.ccStripWatched = 'true';
          if (ccStripObserver) ccStripObserver.observe(container);
          ccStripQueue.push(container);
          ccScheduleStrips();
        }
        return;
      }
      ccFillThumbs(container);

      if (container.dataset.thumbsBound) {
        initVariantSliders(container);
        return;
      }
      container.dataset.thumbsBound = 'true';

      var gridItem = container.closest('[data-grid-item]');
      if (!gridItem) {
        // console.log('[CC] No grid-item found');
        return; 
      }

      var productImageWrap = gridItem.querySelector('[data-product-image]');
      if (!productImageWrap) {
        // console.log('[CC] No product-image wrapper found');
        return;
      }

      var defaultImageDiv = productImageWrap.querySelector('[data-product-image-default]');
      var thumbs = container.querySelectorAll('[data-variant-thumb-title]');
      var overlays = productImageWrap.querySelectorAll('[data-variant-title]');

      // console.log('[CC] Grid item:', gridItem.id, '| thumbs:', thumbs.length, '| overlays:', overlays.length, '| defaultImageDiv:', !!defaultImageDiv);

      // Log what overlays exist vs what thumb titles we have
      overlays.forEach(function(el) {
        // console.log('[CC]   overlay data-variant-title:', el.getAttribute('data-variant-title'));
      });
      thumbs.forEach(function(el) {
        // console.log('[CC]   thumb data-variant-thumb-title:', el.getAttribute('data-variant-thumb-title'));
      });

      // Shared: show a variant's image — theme's pre-rendered overlay when one
      // exists (Strategy 1), else direct src swap (Strategy 2). Used by hover
      // preview, click-to-select and mouseleave restore.
      function ccShowVariant(variantTitle, variantSrc) {
        var matched = false;
        overlays.forEach(function(el) {
          el.classList.remove('is-visible');
        });

        if (variantTitle && overlays.length > 0) {
          var selected = productImageWrap.querySelector('[data-variant-title="' + variantTitle + '"]');
          if (selected) {
            selected.classList.add('is-visible');
            matched = true;
          }
        }

        if (!matched && variantSrc && defaultImageDiv) {
          var mainImg = defaultImageDiv.querySelector('img');
          if (mainImg) {
            if (!mainImg.dataset.originalSrc) {
              mainImg.dataset.originalSrc = mainImg.currentSrc || mainImg.src;
            }
            if (mainImg.getAttribute('srcset') && !mainImg.dataset.originalSrcset) {
              mainImg.dataset.originalSrcset = mainImg.getAttribute('srcset');
            }
            mainImg.removeAttribute('srcset');
            mainImg.src = variantSrc;
          }
        }

        // The hover-images layer (2nd-image hover on desktop, always-visible
        // swipe gallery on touch) is z-index:1 ABOVE the bg we just swapped —
        // on touch the swap would be invisible under it. Hide it inline while
        // a variant image is showing; ccRestoreDefault clears these so the
        // theme's own behaviour returns on unselected cards.
        if (matched || variantSrc) {
          var hoverImages = productImageWrap.querySelector('hover-images');
          if (hoverImages) {
            hoverImages.style.opacity = '0';
            hoverImages.style.visibility = 'hidden';
            hoverImages.style.pointerEvents = 'none';
          }
        }
        return matched;
      }

      function ccRestoreDefault() {
        overlays.forEach(function(el) {
          el.classList.remove('is-visible');
        });

        if (defaultImageDiv) {
          var mainImg = defaultImageDiv.querySelector('img');
          if (mainImg && mainImg.dataset.originalSrc) {
            mainImg.src = mainImg.dataset.originalSrc;
            if (mainImg.dataset.originalSrcset) {
              mainImg.setAttribute('srcset', mainImg.dataset.originalSrcset);
            }
          }
        }

        var hoverImages = productImageWrap.querySelector('hover-images');
        if (hoverImages) {
          hoverImages.style.opacity = '';
          hoverImages.style.visibility = '';
          hoverImages.style.pointerEvents = '';
        }
      }

      // Title/price PREVIEW — desktop hover and touch select share this.
      // Lazily snapshots the card's original title/price on first use;
      // ccRestoreInfo puts back the touch SELECTION if one was made, else
      // the original. (Siblings share a display name, so the title swap is
      // usually invisible — the price is what actually changes.)
      function ccPreviewInfo(displayName, priceHtml) {
        // skip redundant DOM writes (re-entering the same swatch, sibling with
        // identical name/price) — every write is a mutation the browser has to
        // style/layout, and hover should be as close to free as possible
        var key = (displayName || '') + '' + (priceHtml || '');
        if (gridItem.__ccInfoKey === key) return;
        gridItem.__ccInfoKey = key;

        if (displayName) {
          var titleEl = gridItem.querySelector('.product-item__title');
          if (titleEl) {
            if (gridItem.__ccOrigTitle === undefined) gridItem.__ccOrigTitle = titleEl.textContent;
            titleEl.textContent = displayName;
          }
        }
        if (priceHtml) {
          var priceEl = gridItem.querySelector('[data-product-price]');
          if (priceEl) {
            if (gridItem.__ccOrigPrice === undefined) gridItem.__ccOrigPrice = priceEl.innerHTML;
            priceEl.innerHTML = priceHtml;
          }
        }
      }

      function ccRestoreInfo() {
        gridItem.__ccInfoKey = null; // next preview must write again
        var titleEl = gridItem.querySelector('.product-item__title');
        var priceEl = gridItem.querySelector('[data-product-price]');
        if (titleEl && gridItem.__ccOrigTitle !== undefined) {
          titleEl.textContent = gridItem.__ccSelTitle !== undefined ? gridItem.__ccSelTitle : gridItem.__ccOrigTitle;
        }
        if (priceEl && gridItem.__ccOrigPrice !== undefined) {
          priceEl.innerHTML = gridItem.__ccSelPrice !== undefined ? gridItem.__ccSelPrice : gridItem.__ccOrigPrice;
        }
      }

      thumbs.forEach(function(thumb) {
        if (thumb.dataset.thumbHoverBound) return;
        thumb.dataset.thumbHoverBound = 'true';

        thumb.addEventListener('mouseenter', function(e) {
          e.stopPropagation();
          ccShowVariant(this.getAttribute('data-variant-thumb-title'), this.getAttribute('data-variant-thumb-src'));
          ccPreviewInfo(this.getAttribute('data-variant-display-name'), this.getAttribute('data-variant-price-html'));
        });

        // TOUCH ONLY — tap SELECTS the colorway instead of navigating (Nike
        // model): the card's image sticks to it and the title, price and links
        // all become the selected colorway — opening the product happens via
        // the image/title. On desktop (hover-capable, fine pointer) hover
        // already previews, so a swatch CLICK keeps its native behaviour:
        // straight to that colorway's PDP.
        thumb.addEventListener('click', function(e) {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return; // desktop: navigate

          var url = this.getAttribute('href');
          if (!url) return; // malformed swatch: keep native navigation

          e.preventDefault();
          e.stopPropagation();

          var variantTitle = this.getAttribute('data-variant-thumb-title') || '';
          var variantSrc = this.getAttribute('data-variant-thumb-src') || '';
          ccShowVariant(variantTitle, variantSrc);

          // persist, so hover previews of other colours restore to the selection
          gridItem.dataset.ccSelectedTitle = variantTitle;
          gridItem.dataset.ccSelectedSrc = variantSrc;

          container.querySelectorAll('.variant-option-img.cc-selected').forEach(function(el) {
            el.classList.remove('cc-selected');
          });
          this.classList.add('cc-selected');

          gridItem.setAttribute('data-url', url);
          gridItem.querySelectorAll('a.product-link').forEach(function(link) {
            link.setAttribute('href', url);
            if (link.hasAttribute('data-product-link')) link.setAttribute('data-product-link', url);
          });

          var displayName = this.getAttribute('data-variant-display-name');
          var priceHtml = this.getAttribute('data-variant-price-html');
          ccPreviewInfo(displayName, priceHtml);
          if (displayName) gridItem.__ccSelTitle = displayName;
          if (priceHtml) gridItem.__ccSelPrice = priceHtml;
        });
      });

      // Restore on mouse leave — to the SELECTED colorway if one was clicked
      if (!gridItem.dataset.variantLeaveBound) {
        gridItem.dataset.variantLeaveBound = 'true';

        gridItem.addEventListener('mouseleave', function() {
          ccRestoreInfo();
          if (gridItem.dataset.ccSelectedTitle || gridItem.dataset.ccSelectedSrc) {
            ccShowVariant(gridItem.dataset.ccSelectedTitle, gridItem.dataset.ccSelectedSrc);
            return;
          }
          ccRestoreDefault();
        });
      }

      initVariantSliders(container);
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantThumbnailSwap);
  } else {
    initVariantThumbnailSwap();
  }

  // Re-run when Shopify sections are reloaded in the theme editor
  document.addEventListener('shopify:section:load', initVariantThumbnailSwap);
  document.addEventListener('theme:recently-viewed:loaded', initVariantThumbnailSwap);

  // CRNR: viewed colorway siblings arrive as identical cards (children are
  // upgraded to their family parent in api-product-grid-item.liquid), so
  // keep the first card per displayed title and drop the rest. Capture phase
  // so this runs before related-products.js counts the cards and reveals
  // the section.
  document.addEventListener('theme:recently-viewed:loaded', function(e) {
    var recentlyViewed = e.target;
    if (!recentlyViewed || !recentlyViewed.querySelectorAll) return;
    var ccSeen = {};
    recentlyViewed.querySelectorAll('[data-grid-item]').forEach(function(card) {
      var titleEl = card.querySelector('.product-item__title');
      var key = titleEl ? titleEl.textContent.trim() : card.getAttribute('data-url');
      if (!key) return;
      if (ccSeen[key]) card.remove();
      else ccSeen[key] = true;
    });
  }, true);

  // Re-run when "Load More" / infinite scroll (Ajaxinate) appends new product
  // cards. Ajaxinate fires no DOM event and is initialized without a callback,
  // so we watch each results container (#AjaxinateLoop) for appended children
  // and re-run. initVariantThumbnailSwap() is idempotent (it skips cards
  // already bound), so this only binds the new cards.
  function observeAjaxinateLoops() {
    var loops = document.querySelectorAll('#AjaxinateLoop');
    loops.forEach(function(loop) {
      if (loop.dataset.swatchObserver) return;
      loop.dataset.swatchObserver = 'true';
      var t;
      new MutationObserver(function() {
        // Fire on the next frame so a burst of appended cards is coalesced into
        // a single pass.
        clearTimeout(t);
        t = setTimeout(initVariantThumbnailSwap, 0);
      }).observe(loop, { childList: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAjaxinateLoops);
  } else {
    observeAjaxinateLoops();
  }

  /* ---- Nike-style swatch carousel arrows (ALL product cards site-wide) -------
     The theme's grid-slider doesn't reliably build arrows for the JS-injected
     swatch rows, so we add our own. For each swatch row that OVERFLOWS we inject
     prev/next chevrons that smooth-scroll it. They're hidden at rest and fade in
     on card hover (CSS); prev is hidden at the start and next at the end (Nike
     behaviour). Overlay-text cards are skipped (they keep theme styling).
     Idempotent: rows are tagged with data-cc-arrows. */
  function ccUpdateSwatchArrows(row) {
    if (!row.__ccPrev) return;
    var max = row.scrollWidth - row.clientWidth;
    var atStart = row.scrollLeft <= 2;
    var atEnd = row.scrollLeft >= max - 2;
    row.__ccPrev.classList.toggle('is-hidden', atStart);
    row.__ccNext.classList.toggle('is-hidden', atEnd);
    // rest-state edge fades follow the same logic (no fade once you hit that end)
    if (row.__ccWrap) {
      row.__ccWrap.classList.toggle('cc-at-start', atStart);
      row.__ccWrap.classList.toggle('cc-at-end', atEnd);
    }
  }
  function ccBuildSwatchArrows(row) {
    // Runs at ALL widths: the scroll listener + cc-at-start/cc-at-end classes
    // drive the edge fades on mobile too. The chevron buttons themselves are
    // display:none'd below 990px in CSS (touch users swipe, like Nike).
    if (row.closest('.product-item--overlay-text')) return; // overlay cards keep theme styling
    if (row.dataset.ccArrows) { ccUpdateSwatchArrows(row); return; }
    if (row.clientWidth === 0) return; // hidden (inactive tab etc.) — retry via observer when shown
    if (row.scrollWidth <= row.clientWidth + 2) return; // fits: no arrows needed
    var wrap = row.closest('.product-item__variants');
    if (!wrap) return;
    // if the row subtree was replaced (filters/section reload) the wrap survives
    // with orphaned buttons while the new row is untagged — clear them or they stack
    wrap.querySelectorAll('.cc-swatch-arrow').forEach(function(old) { old.remove(); });
    row.dataset.ccArrows = '1';
    wrap.classList.add('cc-has-arrows');
    var svg =
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'cc-swatch-arrow cc-swatch-arrow--prev is-hidden';
    next.className = 'cc-swatch-arrow cc-swatch-arrow--next';
    prev.setAttribute('aria-label', 'Previous colors');
    next.setAttribute('aria-label', 'Next colors');
    prev.innerHTML = next.innerHTML = svg;
    wrap.appendChild(prev);
    wrap.appendChild(next);
    row.__ccPrev = prev;
    row.__ccNext = next;
    row.__ccWrap = wrap;
    var step = function() { return Math.max(row.clientWidth * 0.8, 120); };
    prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', function() { ccUpdateSwatchArrows(row); }, { passive: true });
    ccUpdateSwatchArrows(row);
  }
  function ccInitSwatchCarousels() {
    requestAnimationFrame(function() {
      document.querySelectorAll('.product-item__variants .grid--slider').forEach(ccBuildSwatchArrows);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccInitSwatchCarousels);
  else ccInitSwatchCarousels();
  window.addEventListener('resize', function() {
    document.querySelectorAll('.product-item__variants .grid--slider').forEach(function(row) {
      if (row.dataset.ccArrows) ccUpdateSwatchArrows(row); else ccBuildSwatchArrows(row);
    });
  });
  (function() {
    // Re-init ONLY when new product cards actually enter the DOM (related
    // products, recently viewed, load-more, filter swaps, upsells). The
    // observer deliberately ignores attribute/class churn and unrelated
    // childList noise: our own hover behaviour writes the price/title DOM on
    // every mouseenter, and reacting to that created a feedback loop of
    // constant global re-inits that made hover unreliable. Filtering the
    // records to "an element containing a swatch container was ADDED" makes
    // that loop structurally impossible — nothing we mutate during hover
    // (price innerHTML, classes, arrow buttons) matches the filter.
    var pending = null;
    var lastRun = 0;
    var kick = function() {
      if (pending) return;
      var wait = Math.max(0, 300 - (Date.now() - lastRun));
      pending = setTimeout(function() {
        pending = null;
        lastRun = Date.now();
        // Both are idempotent: bound cards early-return, arrows re-tag.
        initVariantThumbnailSwap();
        ccInitSwatchCarousels();
      }, wait);
    };
    new MutationObserver(function(records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue; // elements only
          if (n.matches('[data-variant-thumbnails], [data-grid-item]') ||
              n.querySelector('[data-variant-thumbnails], [data-grid-item]')) {
            kick();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', kick);
  })();

  // Re-run when collection filter/sort AJAX replaces the product grid.
  // The filter form (<collection-filters-form>) fetches new HTML and
  // replaces innerHTML of [data-products-grid], which destroys the old
  // <grid-swatch> elements and the #AjaxinateLoop MutationObserver.
  // Watch the grid container for childList changes so we can re-init
  // swatches and re-observe the new Ajaxinate loop.
  function observeCollectionGridChanges() {
    var grids = document.querySelectorAll('[data-products-grid]');
    grids.forEach(function(grid) {
      if (grid.dataset.gridFilterObserver) return;
      grid.dataset.gridFilterObserver = 'true';
      var t;
      new MutationObserver(function() {
        clearTimeout(t);
        t = setTimeout(function() {
          initVariantThumbnailSwap();
          observeAjaxinateLoops();
        }, 0);
      }).observe(grid, { childList: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCollectionGridChanges);
  } else {
    observeCollectionGridChanges();
  }

  /* ---- Load more ----------------------------------------------------------
     Collection and search pages use the theme's Ajaxinate loader. It always
     starts in scroll mode, so when a grid has the Load more button
     (.pagination--load-more) we switch it to click mode as it is created: one
     hook on ajaxinate-items' init covers first load, filter and sort changes
     and theme editor reloads.
     The next page is fetched as soon as the grid is set up (and again after
     each append), so a click appends at once. It fetches only the grid section
     (section_id, about 0.3 MB) instead of the whole page (about 5 MB). */

  // The theme clears an image's loading shimmer via a global 'load' listener,
  // plus a one-time sweep at DOMContentLoaded (removeLoadingClassFromLoadedImages)
  // for images that are already `complete`. It never re-runs that sweep on
  // appended content, so a cached image that appends `complete` (no load event
  // fires) stays shimmering forever. Run the theme's own sweep on the appended
  // cards so cached images pop in instantly; genuinely-downloading images keep
  // their native shimmer until the bytes arrive (that part is inherent).
  function ccLmSweepLoadingImages(root) {
    if (!root) return;
    root.querySelectorAll('img.is-loading').forEach(function(img) {
      var clear = function() {
        img.classList.remove('is-loading');
        var p = img.parentNode;
        if (p) {
          p.classList.remove('is-loading');
          if (p.parentNode && p.parentNode.classList.contains('is-loading')) p.parentNode.classList.remove('is-loading');
        }
      };
      if (img.complete) clear();
      else img.addEventListener('load', clear, { once: true });
    });
  }

  function ccLmSectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  // Fetch the next page's grid section once per URL; hover, touch and click share it.
  function ccLmFetch(inst) {
    var link = inst.paginationElement && inst.paginationElement.querySelector('a');
    if (!link || !link.href) return null;
    var url = link.href;
    if (inst.__ccNext && inst.__ccNext.url === url) return inst.__ccNext;

    var next = { url: url };
    next.promise = fetch(ccLmSectionUrl(url, inst.__ccSectionId))
      .then(function(r) {
        if (!r.ok) throw new Error('Load more HTTP ' + r.status);
        return r.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var container = doc.querySelector(inst.settings.container);
        if (!container) throw new Error('Load more: grid not found');
        return { container: container, pagination: doc.querySelector(inst.settings.pagination), doc: doc };
      })
      .catch(function() {
        if (inst.__ccNext === next) inst.__ccNext = null;
        return null;
      });
    inst.__ccNext = next;
    return next;
  }

  function ccLmApply(inst, data) {
    var cardSelector = '[data-grid-item].product-item';
    var before = inst.containerElement.querySelectorAll(cardSelector).length;
    inst.containerElement.insertAdjacentHTML('beforeend', data.container.innerHTML);
    // the new cards' photos first: ahead of their (low priority) swatch thumbs
    [].slice.call(inst.containerElement.querySelectorAll(cardSelector), before, before + 8).forEach(function(card) {
      var img = card.querySelector('[data-product-image-default] img');
      if (img) img.setAttribute('fetchpriority', 'high');
    });
    if (!data.pagination) {
      inst.removePaginationElement();
    } else {
      inst.paginationElement.innerHTML = data.pagination.innerHTML;
      if (inst.settings.callback && typeof inst.settings.callback === 'function') {
        inst.settings.callback(data.doc);
      }
      inst.initialize();
      ccLmFetch(inst); // get the following page ready for the next click
    }
    ccLmSweepLoadingImages(inst.containerElement);
  }

  function ccLmConfigure(itemsEl) {
    var inst = itemsEl.endlessScroll;
    if (!inst || inst.__ccConfigured || !inst.paginationElement) return;
    inst.__ccConfigured = true;
    inst.__ccSectionId = itemsEl.dataset.ajaxinateId;

    var pagination = inst.paginationElement;
    if (pagination.classList.contains('pagination--load-more')) {
      inst.destroy(); // drop the scroll listeners it started with
      inst.settings.method = 'click';
      if (pagination.dataset.loadingText) inst.settings.loadingText = pagination.dataset.loadingText;
      inst.initialize();

      var warm = function(e) {
        if (e.target.closest && e.target.closest('a')) ccLmFetch(inst);
      };
      pagination.addEventListener('pointerenter', warm, true);
      pagination.addEventListener('pointerdown', warm, true);
      pagination.addEventListener('focusin', warm);

      // Fetch the next page as soon as this grid is set up, so a click appends at once.
      setTimeout(function() { ccLmFetch(inst); }, 0);
    }

    var origLoadMore = inst.loadMore.bind(inst);
    inst.loadMore = function() {
      var next = inst.__ccSectionId ? ccLmFetch(inst) : null;
      if (!next) return origLoadMore();
      next.promise.then(function(data) {
        if (data) ccLmApply(inst, data);
        else origLoadMore(); // section fetch failed: fall back to the theme's full-page load
      });
    };
  }

  function ccLmHook() {
    var Items = customElements.get('ajaxinate-items');
    if (!Items || Items.prototype.__ccHooked) return;
    Items.prototype.__ccHooked = true;
    var init = Items.prototype.init;
    Items.prototype.init = function() {
      init.call(this);
      ccLmConfigure(this);
    };
    // grids that started before this hook existed
    document.querySelectorAll('ajaxinate-items').forEach(ccLmConfigure);
  }
  if (window.customElements) customElements.whenDefined('ajaxinate-items').then(ccLmHook);

  // --- No default size ---
  // Size options render unchecked until the customer picks one (see
  // snippets/cc-size-options.liquid). On a color change the size carries over
  // only if the new color has it: data-cc-size-variant on each swatch is that
  // color's variant for the current size, empty if there isn't one.
  //
  // When the size is dropped, request one real variant of the new color
  // (ccSwapVariant) and clear the size on the fetched HTML (ccClearSize).
  // Requesting the color alone makes Shopify fill in the listing's first size,
  // which returns no variant when the color doesn't come in it (HMIT
  // Red/Black). The variant is data-cc-size-variant or the ?variant= in the
  // swatch's URL.
  var ccSwapWithoutSize = false;
  var ccSwapVariant = null;

  function ccSizeInputs(root) {
    return root ? root.querySelectorAll('variant-selects input[data-cc-size]') : [];
  }

  function ccUrlVariant(url) {
    var match = /[?&]variant=(\d+)/.exec(url || '');
    return match ? match[1] : null;
  }

  // Capture phase, so this runs before variant-selects builds the request.
  document.addEventListener('change', function(e) {
    var input = e.target;
    ccSwapVariant = null;
    if (!input || input.tagName !== 'INPUT' || !input.closest('.radio__fieldset--swatches')) return;
    var productInfo = input.closest('product-info');
    var url = (input.getAttribute('data-product-url') || '').split('?')[0];
    if (!productInfo || !url || url === productInfo.getAttribute('data-url')) return;

    var sizes = ccSizeInputs(productInfo);
    var chosen = null;
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i].checked) chosen = sizes[i];
    }
    var sameSize = input.getAttribute('data-cc-size-variant');
    var fallback = ccUrlVariant(input.getAttribute('data-product-url'));
    ccSwapWithoutSize = false;
    if (sizes.length) {
      if (chosen && !sameSize) chosen.checked = false;
      ccSwapWithoutSize = !chosen || !sameSize;
      if (ccSwapWithoutSize) ccSwapVariant = sameSize || fallback;
    } else if (!sameSize) {
      // Quick add keeps a size selected. If the new color doesn't have it, use
      // the variant from the swatch's URL.
      ccSwapVariant = fallback;
    }
  }, true);

  // Request ccSwapVariant instead of the option values (used once, then cleared).
  if (window.customElements) {
    customElements.whenDefined('product-info').then(function() {
      var proto = customElements.get('product-info').prototype;
      var build = proto.buildRequestUrlWithParams;
      if (typeof build !== 'function') return;
      proto.buildRequestUrlWithParams = function(url, optionValues, fullPage) {
        var variant = ccSwapVariant;
        ccSwapVariant = null;
        if (!variant) return build.call(this, url, optionValues, fullPage);
        var built = build.call(this, url, [], fullPage);
        return built + (built.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant;
      };
    });
  }

  // Product information accordions live outside <product-info>, so a color
  // change didn't update them. Request those sections in the same call
  // (sections= takes up to five) and swap in the new text, leaving open/closed
  // state alone. Falls back to the theme's request if this fails. Size changes
  // are unaffected.
  function ccFollowIds(productInfo) {
    if (!productInfo.closest('main') || !/^MainProduct/.test(productInfo.id || '')) return [];
    var ids = [];
    var els = document.querySelectorAll('[data-cc-follow-product]');
    for (var i = 0; i < els.length && ids.length < 4; i++) {
      var id = els[i].getAttribute('data-cc-follow-product');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function ccItemTitle(item) {
    var trigger = item.querySelector('[data-collapsible-trigger]');
    return trigger ? trigger.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function ccUpdateFollowers(json, ids) {
    ids.forEach(function(id) {
      var current = document.querySelector('[data-cc-follow-product="' + id + '"]');
      if (!current || typeof json[id] !== 'string') return;
      var fresh = new DOMParser().parseFromString(json[id], 'text/html').querySelector('[data-cc-follow-product="' + id + '"]');
      if (!fresh) return;
      var oldItems = current.querySelectorAll('[data-collapsible]');
      var newItems = fresh.querySelectorAll('[data-collapsible]');
      var same = oldItems.length === newItems.length;
      for (var i = 0; same && i < oldItems.length; i++) same = ccItemTitle(oldItems[i]) === ccItemTitle(newItems[i]);
      if (same) {
        for (var j = 0; j < oldItems.length; j++) {
          var oldContent = oldItems[j].querySelector('[data-collapsible-content]');
          var newContent = newItems[j].querySelector('[data-collapsible-content]');
          if (oldContent && newContent && oldContent.innerHTML !== newContent.innerHTML) oldContent.innerHTML = newContent.innerHTML;
        }
        return;
      }
      // Different blocks for this color: replace the whole group, without the
      // scroll-in animation so it shows right away.
      var animated = fresh.querySelectorAll('[data-aos]');
      for (var k = 0; k < animated.length; k++) animated[k].removeAttribute('data-aos');
      current.innerHTML = fresh.innerHTML;
    });
  }

  if (window.customElements) {
    customElements.whenDefined('product-info').then(function() {
      var proto = customElements.get('product-info').prototype;
      var render = proto.renderProductInfo;
      if (typeof render !== 'function') return;
      proto.renderProductInfo = function(opts) {
        var self = this;
        var main = self.sectionId;
        var param = 'section_id=' + main;
        var requestUrl = (opts && opts.requestUrl) || '';
        var isSwap = requestUrl.indexOf(param) !== -1 && requestUrl.split('?')[0] !== self.getAttribute('data-url');
        var ids = isSwap ? ccFollowIds(self) : [];
        if (!ids.length) return render.call(self, opts);

        if (self.abortController) self.abortController.abort();
        var controller = self.abortController = new AbortController();
        fetch(requestUrl.replace(param, 'sections=' + [main].concat(ids).join(',')), { signal: controller.signal })
          .then(function(response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then(function(json) {
            if (!json || typeof json[main] !== 'string') throw new Error('no product section in the response');
            return json;
          })
          .then(function(json) {
            self.pendingRequestUrl = null;
            opts.callback(new DOMParser().parseFromString(json[main], 'text/html'));
            try {
              ccUpdateFollowers(json, ids);
              ccSyncSkuLines();
            } catch (e) {
              console.warn('CRNR: product information not updated', e);
            }
            var target = opts.targetId && document.getElementById(opts.targetId);
            if (target) target.focus({ preventScroll: true });
          }, function(error) {
            if (controller.signal.aborted || error.name === 'AbortError') return;
            render.call(self, opts);
          });
      };
    });
  }

  function ccSetButtonLabel(productInfo, variantSelects) {
    var label = (variantSelects && variantSelects.getAttribute('data-cc-select-label')) || 'Select Size';
    var text = productInfo.querySelector('[data-add-to-cart-text]');
    if (!text) return;
    if (text.firstChild && text.firstChild.nodeType === 3) {
      text.firstChild.nodeValue = label;
    } else {
      text.insertBefore(text.ownerDocument.createTextNode(label), text.firstChild);
    }
  }

  // Reset a fetched <product-info> to "no size selected" before it's inserted.
  // Attributes only, since the theme rebuilds the node from its outerHTML.
  function ccClearSize(productInfo) {
    var sizes = ccSizeInputs(productInfo);
    if (!sizes.length) return false;
    for (var i = 0; i < sizes.length; i++) sizes[i].removeAttribute('checked');

    var fieldset = sizes[0].closest('fieldset');
    var legend = fieldset && fieldset.querySelector('[data-selected-value]');
    if (legend) legend.textContent = '';

    var variantSelects = productInfo.querySelector('variant-selects');
    var json = variantSelects && variantSelects.querySelector('[data-selected-variant]');
    if (json) json.textContent = 'null';

    var form = productInfo.querySelector('product-form');
    if (form) form.setAttribute('data-cc-size-required', '');
    var idInput = productInfo.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (idInput) idInput.setAttribute('value', '');
    var wrapper = productInfo.querySelector('[data-form-wrapper]');
    if (wrapper) wrapper.classList.remove('variant--soldout');
    var button = productInfo.querySelector('[data-add-to-cart]');
    if (button) button.setAttribute('disabled', '');
    ccSetButtonLabel(productInfo, variantSelects);
    return true;
  }

  // Same-color change to a combination that doesn't exist: show "Select Size"
  // instead of the theme's "Unavailable".
  function ccAfterOptionsUpdate(variantSelects) {
    var json = variantSelects.querySelector('[data-selected-variant]');
    if (!json || json.textContent.trim() !== 'null') return;
    setTimeout(function() {
      var productInfo = variantSelects.closest('product-info');
      if (!productInfo || !ccSizeInputs(productInfo).length) return;
      var form = productInfo.querySelector('product-form');
      if (form) form.setAttribute('data-cc-size-required', '');
      ccSetButtonLabel(productInfo, variantSelects);
    }, 0);
  }

  // App widgets (Yotpo stars, Shop Pay installments) render empty in a swapped
  // product and fill in later. Hold each at its previous height until then
  // (3 s max) so the options don't jump.
  var CC_HOLD = '.shopify-app-block[id], form[id^="product-form-installment"]';

  function ccMeasureHolds(root) {
    var heights = {};
    var els = root.querySelectorAll(CC_HOLD);
    for (var i = 0; i < els.length; i++) {
      var h = els[i].getBoundingClientRect().height;
      // getAttribute: form.id returns the form's <input name="id">.
      if (h > 0) heights[els[i].getAttribute('id')] = h;
    }
    return heights;
  }

  function ccContentHeight(el) {
    var top = Infinity;
    var bottom = -Infinity;
    for (var i = 0; i < el.children.length; i++) {
      var r = el.children[i].getBoundingClientRect();
      if (r.height > 0) {
        top = Math.min(top, r.top);
        bottom = Math.max(bottom, r.bottom);
      }
    }
    return bottom > top ? bottom - top : 0;
  }

  function ccApplyHolds(root, heights) {
    Object.keys(heights).forEach(function(id) {
      var el = root.querySelector('#' + CSS.escape(id));
      var target = heights[id];
      if (!el || ccContentHeight(el) >= target - 1) return;
      el.style.minHeight = target + 'px';
      var started = performance.now();
      var last = -1;
      var steady = 0;
      (function check() {
        var h = ccContentHeight(el);
        steady = h > 0 && Math.abs(h - last) < 1 ? steady + 1 : 0;
        last = h;
        if (!el.isConnected || h >= target - 1 || steady >= 10 || performance.now() - started > 3000) {
          el.style.minHeight = '';
          return;
        }
        requestAnimationFrame(check);
      })();
    });
  }

  // Keep the options in place when a color change replaces the product section:
  //  1. Carry product-sticky's offset over to the new column and pause it until
  //     the next scroll, click or key.
  //  2. If the section gets shorter (fewer photos), scroll by however far the
  //     options moved, but only while scrolling actually moves them.
  var CC_STICKY_STATE = ['stickyDefaultTop', 'stickyScrollTop', 'currentPoint', 'scrollDirectionDown'];
  var CC_STICKY_PAUSED = -1; // any truthy value stops product-sticky scheduling a recalculation

  function ccCaptureAnchor(oldNode) {
    var vs = oldNode.querySelector('variant-selects');
    var sticky = oldNode.querySelector('product-sticky');
    var state = null;
    if (sticky && typeof sticky.calculateStickyPosition === 'function') {
      state = {};
      CC_STICKY_STATE.forEach(function(k) { state[k] = sticky[k]; });
    }
    return { top: vs ? vs.getBoundingClientRect().top : null, sticky: state };
  }

  function ccSyncSticky(sticky) {
    if (!sticky) return;
    sticky.scrollTopPosition = window.scrollY;
    sticky.scrollLastPosition = window.scrollY;
  }

  function ccRestoreAnchor(newNode, anchor) {
    var sticky = newNode.querySelector('product-sticky');
    if (sticky && anchor.sticky && typeof sticky.calculateStickyPosition === 'function') {
      sticky.removeAnimationFrameSticky(); // drop the reset it queued on connect
      CC_STICKY_STATE.forEach(function(k) { sticky[k] = anchor.sticky[k]; });
      sticky.stickyScrollTop = anchor.sticky.currentPoint;
      sticky.stickyFormLoad = false;
      sticky.requestAnimationSticky = CC_STICKY_PAUSED;
      ccSyncSticky(sticky);
      var wrapper = sticky.querySelector('[data-form-wrapper]');
      if (wrapper) wrapper.style.setProperty('--sticky-top', anchor.sticky.currentPoint + 'px');
    } else {
      sticky = null;
    }

    var done = false;
    var events = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    var release = function() {
      if (done) return;
      done = true;
      events.forEach(function(t) { window.removeEventListener(t, release, true); });
      if (sticky && sticky.requestAnimationSticky === CC_STICKY_PAUSED) {
        sticky.requestAnimationSticky = null;
        ccSyncSticky(sticky);
      }
    };
    events.forEach(function(t) { window.addEventListener(t, release, { capture: true, passive: true }); });

    if (anchor.top === null) return;
    var started = performance.now();
    (function settle() {
      if (done) return;
      var vs = newNode.isConnected && newNode.querySelector('variant-selects');
      if (!vs) return release();
      var top = vs.getBoundingClientRect().top;
      var delta = top - anchor.top;
      if (Math.abs(delta) > 2) {
        var y = window.scrollY;
        window.scrollBy({ top: delta, behavior: 'instant' });
        // Pinned column: scrolling doesn't move the options, so undo it and stop.
        if (Math.abs(vs.getBoundingClientRect().top - top) < 1) {
          window.scrollTo({ top: y, behavior: 'instant' });
          return;
        }
        ccSyncSticky(sticky);
      }
      if (performance.now() - started < 1500) requestAnimationFrame(settle);
    })();
  }

  // --- Preserve visual position through ALL product changes ---
  var ccVariantChanging = false;
  var ccScrollLock = 0;

  // Mark the product while a variant loads so the disabled button doesn't fade
  // (crnr-custom.css.liquid).
  var ccLoadingTimer = null;
  function ccClearLoading() {
    clearTimeout(ccLoadingTimer);
    document.querySelectorAll('product-info[data-cc-loading]').forEach(function(el) {
      el.removeAttribute('data-cc-loading');
    });
  }

  window.subscribe('option-value-selection-change', function(detail) {
    ccVariantChanging = true;
    ccScrollLock = window.scrollY;
    var target = detail && detail.data && detail.data.target;
    var loadingInfo = target && target.closest ? target.closest('product-info') : null;
    if (loadingInfo) {
      loadingInfo.setAttribute('data-cc-loading', '');
      clearTimeout(ccLoadingTimer);
      ccLoadingTimer = setTimeout(ccClearLoading, 4000);
    }
  });

  window.subscribe('variant-change', function(detail) {
    setTimeout(function() {
      ccVariantChanging = false;
      if (Math.abs(window.scrollY - ccScrollLock) > 1) {
        window.scrollTo({ top: ccScrollLock, behavior: 'instant' });
      }
    }, 100);
    ccClearLoading();

    var variant = detail && detail.data && detail.data.variant;

    // Sync the form wrapper's variant--soldout state to the selected variant.
    // The theme only toggles this class when show-product-notification is on
    // the wrapper, which never happens on the product page, so a page that
    // server-rendered variant--soldout (Combined Listing swap landing on an
    // unavailable colour+size) would keep the payment button dimmed (theme
    // CSS: .variant--soldout .shopify-payment-button) forever even after an
    // available size is selected. Driving it from variant-change keeps the
    // payment button always displayed: dimmed/disabled while unavailable,
    // full/enabled once an available variant is picked.
    if (variant && typeof variant === 'object' && typeof variant.available === 'boolean') {
      var ccFormWrapper = document.querySelector('product-info [data-form-wrapper]');
      if (ccFormWrapper) {
        ccFormWrapper.classList.toggle('variant--soldout', !variant.available);
      }
      // A size is chosen: bring back the button price and express checkout.
      var ccSizeForm = document.querySelector('product-info product-form[data-cc-size-required]');
      if (ccSizeForm) ccSizeForm.removeAttribute('data-cc-size-required');
    }

    // Don't replace shopify-accelerated-checkout or shopify-payment-terms here:
    // it blanked the installments line on every size change. The theme updates
    // their variant id and theme.dev.js re-inits the payment button.
  });

  var origThemeScrollTo = window.theme.scrollTo;
  window.theme.scrollTo = function(elementTop) {
    if (ccVariantChanging) return;
    origThemeScrollTo(elementTop);
  };

  // Keep the "Design Your Own" swatch (added by the cc-utilities Swatch Injector
  // embed) when the swatch row is replaced. The embed re-adds it on a delay, so
  // copy it into the new row before insert, after the same swatch. If that
  // swatch isn't found, the embed adds it back as usual.
  function ccCarryDoorways(oldNode, newContent) {
    if (!newContent || !newContent.querySelectorAll) return;
    var chips = oldNode.querySelectorAll('[data-crnr-doorway]');
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var rule = chip.getAttribute('data-crnr-doorway');
      if (newContent.querySelector('[data-crnr-doorway="' + CSS.escape(rule) + '"]')) continue;
      var before = chip.previousElementSibling && chip.previousElementSibling.querySelector('input');
      if (!before) continue;
      var inputs = newContent.querySelectorAll('.radio__fieldset--swatches input');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value !== before.value) continue;
        var swatch = inputs[j].closest('.swatch__button');
        if (swatch && swatch.parentNode) swatch.parentNode.insertBefore(chip.cloneNode(true), swatch.nextSibling);
        break;
      }
    }
  }

  // Wrap viewTransition to stop scroll anchoring during swaps. A color change
  // replaces <product-info> (no data-update-url, so never <main>): hold app
  // widgets at their height and apply "no size selected" before insert.
  if (typeof HTMLUpdateUtility !== 'undefined' && typeof HTMLUpdateUtility.viewTransition === 'function') {
    var html = document.documentElement;
    var origViewTransition$1 = HTMLUpdateUtility.viewTransition.bind(HTMLUpdateUtility);
    HTMLUpdateUtility.viewTransition = function(oldNode, newContent, preCbs, postCbs) {
      ccScrollLock = window.scrollY;
      html.style.overflowAnchor = 'none';
      document.body.style.overflowAnchor = 'none';

      var isSwap = oldNode.tagName === 'PRODUCT-INFO' || oldNode.tagName === 'MAIN';
      var holds = isSwap ? ccMeasureHolds(oldNode) : null;
      var anchor = isSwap ? ccCaptureAnchor(oldNode) : null;
      var clearedSize = isSwap && ccSwapWithoutSize && !!newContent && ccClearSize(newContent);
      if (isSwap) ccSwapWithoutSize = false;
      if (isSwap || oldNode.tagName === 'VARIANT-SELECTS') ccCarryDoorways(oldNode, newContent);

      origViewTransition$1(oldNode, newContent, preCbs, [function(newNode) {
        if (postCbs && postCbs.length) {
          for (var i = 0; i < postCbs.length; i++) {
            postCbs[i](newNode);
          }
        }
        if (holds) ccApplyHolds(newNode, holds);
        html.style.overflowAnchor = '';
        document.body.style.overflowAnchor = '';
        if (Math.abs(window.scrollY - ccScrollLock) > 1) {
          window.scrollTo({ top: ccScrollLock, behavior: 'instant' });
        }
        if (isSwap) {
          ccVariantChanging = false;
          ccClearLoading();
          if (anchor) ccRestoreAnchor(newNode, anchor);
          // handleSwapProduct has already written ?variant=<first size> to the URL.
          if (clearedSize) {
            window.history.replaceState({}, '', (newNode.getAttribute && newNode.getAttribute('data-url')) || location.pathname);
          }
        }
        if (oldNode.tagName === 'VARIANT-SELECTS') {
          ccAfterOptionsUpdate(newNode);
          setTimeout(ccClearLoading, 0);
        }
      }]);
    };
  }

  // --- Shop Pay and Yotpo after product changes ---
  // The Shop Pay button keeps the old variant id after a variant change, and a
  // color swap replaces Yotpo's widgets without re-running Yotpo's script.
  function ccReinitPaymentButton() {
    document.querySelectorAll('shopify-accelerated-checkout').forEach(function(el) {
      el.removeAttribute('variant-id');
    });
    if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
  }

  function ccReinitYotpo() {
    try {
      if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
      } else if (window.yotpo && window.yotpo.initWidgets) {
        window.yotpo.initWidgets();
      }
    } catch (e) {
      console.warn('Yotpo re-init failed:', e);
    }
  }

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(detail) {
      if (!detail || !detail.data || !detail.data.variant) return;
      // Two frames, so the new variant's markup is in place first.
      requestAnimationFrame(function() {
        requestAnimationFrame(ccReinitPaymentButton);
      });
    });
  }

  // A color swap replaces product-info and does not publish variantChange.
  // Yotpo is not re-initialized on variantChange: a size change keeps the same
  // product, and re-initializing collapsed the stars and reviews.
  document.addEventListener('theme:product-info:loaded', function() {
    requestAnimationFrame(function() {
      ccReinitYotpo();
      ccReinitPaymentButton();
    });
  });

  // --- Product photo dots on phones ---
  // Dots on the photo, the one showing stretched (crnr-custom.css.liquid). Past
  // 10 photos the dots slide in a window 10 dots wide that keeps the current one
  // near the middle, and the end dots shrink when more photos are past them. A
  // color change replaces the gallery, so this runs again after each product
  // swap and variant change.
  var CC_DOTS_MAX = 10;
  var CC_DOT_STEP = 12; // one dot plus its gap, 6px + 6px in the CSS

  function ccSlideGalleryDots(track, marks, index) {
    var count = marks.length;
    var first = Math.min(Math.max(index - Math.floor((CC_DOTS_MAX - 1) / 2), 0), count - CC_DOTS_MAX);
    var last = first + CC_DOTS_MAX - 1;
    var moreLeft = first > 0;
    var moreRight = last < count - 1;
    track.style.transform = 'translateX(' + (-first * CC_DOT_STEP) + 'px)';
    for (var i = 0; i < count; i++) {
      marks[i].classList.toggle('is-edge', (moreLeft && i === first) || (moreRight && i === last));
      marks[i].classList.toggle('is-near', (moreLeft && i === first + 1) || (moreRight && i === last - 1));
    }
  }

  function ccBuildGalleryDots(slides, count) {
    var dots = document.createElement('div');
    dots.className = 'cc-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    var row = document.createElement('div');
    row.className = 'cc-gallery-dots__row';
    var track = row;
    if (count > CC_DOTS_MAX) {
      var view = document.createElement('div');
      view.className = 'cc-gallery-dots__window';
      track = document.createElement('div');
      track.className = 'cc-gallery-dots__track';
      view.appendChild(track);
      row.appendChild(view);
    }
    var marks = [];
    for (var i = 0; i < count; i++) marks.push(track.appendChild(document.createElement('span')));
    dots.appendChild(row);
    slides.insertAdjacentElement('afterend', dots);

    var first = slides.querySelector(':scope > .product__slide');
    var current = -1;
    var queued = false;
    function update() {
      queued = false;
      var atEnd = slides.scrollLeft > 0 && slides.scrollLeft >= slides.scrollWidth - slides.clientWidth - 2;
      var index = atEnd ? count - 1 : Math.round(slides.scrollLeft / ((first && first.offsetWidth) || slides.clientWidth || 1));
      index = Math.min(count - 1, Math.max(0, index));
      if (index === current) return;
      if (marks[current]) marks[current].classList.remove('is-active');
      current = index;
      marks[index].classList.add('is-active');
      if (track !== row) ccSlideGalleryDots(track, marks, index);
    }
    slides.addEventListener('scroll', function() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function ccInitGalleryDots() {
    var galleries = document.querySelectorAll('main product-info product-images.product__images--mobile-slider');
    for (var i = 0; i < galleries.length; i++) {
      var slides = galleries[i].querySelector('.product__slides');
      if (!slides || galleries[i].querySelector('.cc-gallery-dots')) continue;
      var count = slides.querySelectorAll(':scope > .product__slide').length;
      if (count > 1) ccBuildGalleryDots(slides, count);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ccInitGalleryDots);
  } else {
    ccInitGalleryDots();
  }
  document.addEventListener('theme:product-info:loaded', ccInitGalleryDots);
  window.subscribe('variant-change', function() {
    setTimeout(ccInitGalleryDots, 0);
  });

  // The SKU line under "Product information" copies the product section's SKU
  // block (hidden on phones), which the theme updates on a size pick and
  // replaces on a color change.
  function ccSyncSkuLines() {
    var lines = document.querySelectorAll('[data-cc-sku]');
    var source = document.querySelector('main product-info .product__sku[id^="Sku-"]');
    if (!lines.length || !source) return;
    var text = source.textContent.replace(/\s+/g, ' ').trim();
    if (/:$/.test(text)) text = '';
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].textContent !== text) lines[i].textContent = text;
    }
    if (!source.ccSkuObserver) {
      source.ccSkuObserver = new MutationObserver(ccSyncSkuLines);
      source.ccSkuObserver.observe(source, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ccSyncSkuLines);
  } else {
    ccSyncSkuLines();
  }
  document.addEventListener('theme:product-info:loaded', ccSyncSkuLines);

  // The swatch name label (the theme's one shared tooltip) hides only when the
  // swatch that opened it gets mouseleave. A color change replaces that swatch,
  // and on phones nothing moves the mouse after a tap, so the label stayed up.
  // Close it the theme's way, with its fade.
  document.addEventListener('theme:product-info:loaded', function() {
    document.dispatchEvent(new CustomEvent('theme:tooltip:close', { detail: { hideTransition: true } }));
  });

  // Bundle pages on phones: the builder's photo (cc-bundles) pins under the header
  // while the options scroll beneath it. Mark it while pinned so CSS can give it a
  // soft shadow; none at rest or once it lets go at the end.
  function ccWatchBundlePhoto() {
    if (!document.querySelector('main .cc-bundle')) return;
    var photo = null;
    var queued = false;
    var update = function() {
      queued = false;
      photo = photo || document.querySelector('main product-images.cc-bundle-has-sticky');
      if (!photo) return;
      var style = getComputedStyle(photo);
      var top = parseFloat(style.top) || 0;
      var pinned = style.position === 'sticky' && window.scrollY > 0 && Math.abs(photo.getBoundingClientRect().top - top) < 1;
      photo.classList.toggle('cc-is-pinned', pinned);
    };
    window.addEventListener('scroll', function() {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ccWatchBundlePhoto);
  } else {
    ccWatchBundlePhoto();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
